import { Module } from '@nestjs/common';
import { AuditModule } from '../audit/audit.module';
import { ContabilidadModule } from '../contabilidad/contabilidad.module';
import { GastosModule } from '../gastos/gastos.module';
import { PrismaModule } from '../prisma/prisma.module';
import { RendicionViaticosContabilidadService } from './rendicion-viaticos-contabilidad.service';
import { RendicionViaticosController } from './rendicion-viaticos.controller';
import { RendicionViaticosService } from './rendicion-viaticos.service';
import { RendicionViaticosTesoreriaService } from './rendicion-viaticos-tesoreria.service';

@Module({
  imports: [PrismaModule, AuditModule, ContabilidadModule, GastosModule],
  controllers: [RendicionViaticosController],
  providers: [
    RendicionViaticosService,
    RendicionViaticosContabilidadService,
    RendicionViaticosTesoreriaService,
  ],
  exports: [RendicionViaticosService, RendicionViaticosContabilidadService],
})
export class RendicionViaticosModule {}
